<template>
  <div class="form-group ew-searchable-select">
    <label v-if="label" :for="id">{{ label }}</label>
    <div class="position-relative">
      <input type="text" :id="id" class="form-control" autocomplete="off"
        :value="open ? search : selectedLabel" :placeholder="open ? searchPlaceholder : placeholder"
        @focus="onFocus" @blur="onBlur" @input="onInput($event.target.value)"
        @keydown.down.prevent="moveArrow(1)" @keydown.up.prevent="moveArrow(-1)"
        @keydown.enter.prevent="selectAtArrow" @keydown.esc="close"
        v-b-tooltip.hover.top="tooltip" />
      <i class="bi bi-chevron-down text-muted ew-searchable-select__caret"></i>

      <ul v-if="open && filteredOptions.length" class="list-group position-absolute w-100 mt-1 shadow-sm ew-searchable-select__list">
        <li v-for="(o, i) in filteredOptions" :key="o.value" class="list-group-item list-group-item-action"
          :class="{ active: i === arrow }" @mousedown.prevent="selectOption(o)">
          {{ o.label }}
        </li>
      </ul>
      <div v-else-if="open" class="list-group position-absolute w-100 mt-1 shadow-sm ew-searchable-select__list">
        <div class="list-group-item text-muted small">Sin resultados</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchableSelect',
  props: {
    value: { type: String, default: '' },
    options: { type: Array, required: true }, // [{ value, label }]
    label: { type: String, default: '' },
    id: { type: String, default: '' },
    tooltip: { type: String, default: '' },
    placeholder: { type: String, default: 'Selecciona una opción' },
    searchPlaceholder: { type: String, default: 'Buscar...' },
  },
  data() {
    return {
      open: false,
      search: '',
      arrow: -1,
    };
  },
  computed: {
    selectedLabel() {
      const found = this.options.find((o) => o.value === this.value);
      return found ? found.label : '';
    },
    filteredOptions() {
      const q = this.search.trim().toLowerCase();
      const list = q ? this.options.filter((o) => o.label.toLowerCase().includes(q)) : this.options;
      return list.slice(0, 80);
    },
  },
  methods: {
    onFocus() {
      this.open = true;
      this.search = '';
      this.arrow = -1;
    },
    onBlur() {
      setTimeout(() => { this.open = false; }, 150);
    },
    onInput(val) {
      this.search = val;
      this.open = true;
      this.arrow = -1;
    },
    close() {
      this.open = false;
    },
    moveArrow(delta) {
      if (!this.filteredOptions.length) return;
      const max = this.filteredOptions.length - 1;
      this.arrow = Math.min(max, Math.max(0, this.arrow + delta));
    },
    selectAtArrow() {
      if (this.arrow >= 0 && this.filteredOptions[this.arrow]) {
        this.selectOption(this.filteredOptions[this.arrow]);
      } else if (this.filteredOptions.length === 1) {
        this.selectOption(this.filteredOptions[0]);
      }
    },
    selectOption(opt) {
      this.$emit('input', opt.value);
      this.open = false;
      this.search = '';
      this.arrow = -1;
    },
  },
};
</script>

<style scoped>
.ew-searchable-select__caret {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 0.8rem;
}

.ew-searchable-select__list {
  z-index: 1000;
  max-height: 220px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchableSelect.vue